import React from 'react';
import MigrationFeatureCard from './MigrationFeatureCard';
import { getFeatureIcon } from '../../../../utils/migration/featureIcons';
import type { MigrationFeatureGridProps } from '../../../../types/migration';

const MigrationFeatureGrid: React.FC<MigrationFeatureGridProps> = ({ features }) => {
  if (!Array.isArray(features)) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {features.map((feature, index) => (
        <MigrationFeatureCard
          key={index}
          icon={getFeatureIcon(index)}
          name={feature.name}
          description={feature.description}
        />
      ))}
    </div>
  );
};

export default MigrationFeatureGrid;